const hideFilterArray = ["Community", "tag"];
export const CONTENT_CONSTANTS = {
  ALL: "ALL",
  PUBLISHED: "PUBLISHED",
  DRAFT: "DRAFT",
  UNPUBLISHED: "UNPUBLISHED",
};

export const STATUS_FILTER_OPTIONS = [
  { value: "PUBLISHED", labelKey: "published" },
  { value: "DRAFT", labelKey: "draft" },
  { value: "UNPUBLISHED", labelKey: "unpublished" },
  { value: "SCHEDULED_PUBLISH", labelKey: "scheduled_publish" },
  { value: "SCHEDULED_UNPUBLISH", labelKey: "scheduled_unpublish" },
];

/**
 * "Sort By" menu options for the content listing (KIWI-6058). `value` is the
 * key persisted in the ?sort= URL param and mapped to API variables by
 * mapFetchALL; `labelKey` is the i18n key. NEWEST is the default and matches
 * the pre-existing lastModificationDate DESC ordering.
 *
 * The Published/Created pairs are additions that order on a chosen date column
 * via `sortOptions: { date, date_type }`. Grouped by date column so the menu reads as
 * "which date, then which direction" rather than eight flat choices.
 */
export const CONTENT_SORT_OPTIONS = [
  { value: "newest", labelKey: "newest_first", group: "last_modified" },
  { value: "oldest", labelKey: "oldest_first", group: "last_modified" },
  { value: "published_newest", labelKey: "newest_first", group: "published_date" },
  { value: "published_oldest", labelKey: "oldest_first", group: "published_date" },
  { value: "created_newest", labelKey: "newest_first", group: "created_date" },
  { value: "created_oldest", labelKey: "oldest_first", group: "created_date" },
  { value: "title_az", labelKey: "title_a_z", group: "title" },
  { value: "title_za", labelKey: "title_z_a", group: "title" },
];

/** Group headings for CONTENT_SORT_OPTIONS, in menu order. */
export const CONTENT_SORT_GROUPS = [
  { key: "last_modified", labelKey: "last_modified" },
  { key: "published_date", labelKey: "published_date" },
  { key: "created_date", labelKey: "created_date" },
  { key: "title", labelKey: "title" },
];

export const DEFAULT_CONTENT_SORT = "newest";

/**
 * pass contentType
 * if u want hide in filter in content type add in into array
 * @param type
 */
export const contentTypeBasedHideFilter = (type = "") => {
  return !hideFilterArray.some((ele) => ele === type);
};

export const contentTypeSearchBox = (type) => {
  return ["tag", "Sites"].includes(type);
};
